import React from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";

const LocationFilters = ({ filters, onChange }) => {
  // States for US
  const states = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ];

  // Handle state change
  const handleStateChange = (e) => {
    const state = e.target.value;
    onChange({
      state,
    });
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Location Filters
      </Typography>

      <Box sx={{ mb: 3 }}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="state-select-label">State</InputLabel>
          <Select
            labelId="state-select-label"
            value={filters.state}
            label="State"
            onChange={handleStateChange}
          >
            <MenuItem value="">All States</MenuItem>
            {states.map((state) => (
              <MenuItem key={state} value={state}>
                {state}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Typography variant="subtitle2" gutterBottom>
        Popular Recruiting Regions
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <Chip
          label="Texas High School Football"
          variant="outlined"
          onClick={() => handleStateChange({ target: { value: "TX" } })}
        />
        <Chip
          label="Florida Speed"
          variant="outlined"
          onClick={() => handleStateChange({ target: { value: "FL" } })}
        />
        <Chip
          label="California Talent"
          variant="outlined"
          onClick={() => handleStateChange({ target: { value: "CA" } })}
        />
        <Chip
          label="Ohio Football"
          variant="outlined"
          onClick={() => handleStateChange({ target: { value: "OH" } })}
        />
        <Chip
          label="Georgia Athletes"
          variant="outlined"
          onClick={() => handleStateChange({ target: { value: "GA" } })}
        />
      </Box>
    </Box>
  );
};

export default LocationFilters;
